export const getImages = (imageName) => {
    const image = require(`../Assets/img/${imageName}`);
    return image;
}
